module.exports = __webpack_public_path__ + "05_short_brown.96314d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/05_short_brown.png
// module id = /EWC
// module chunks = 0